import * as CONST from '../ActionTypes';

const initialState = {
  rulesByGroup: [],
  rule: {},
  query: {
    currentPage: 0,
    itemsPerPage: 10,
  },
};

function rule(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // ルールグループIDでルール一覧取得
    // -----------------
    case CONST.GET_RULE_LIST_BY_GROUP_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          rulesByGroup: action.payload,
        },
      );
    case CONST.GET_RULE_LIST_BY_GROUP_FAILURE:
      return Object.assign(
        {},
        state,
        {
          rulesByGroup: [],
        },
      );
    // -----------------
    // ルール詳細取得
    // -----------------
    case CONST.GET_RULE_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          rule: action.payload,
        },
      );
    case CONST.GET_RULE_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          rule: {},
        },
      );
    // -----------------
    // queryパラメータの設定
    // -----------------
    case CONST.SET_RULE_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: Object.assign(
            {},
            state,
            action.payload,
          ),
        },
      );
    default:
      return state;
  }
}

export default rule;
